import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-program-dmusic',
  templateUrl: './program-dmusic.component.html',
  styleUrls: ['./program-dmusic.component.scss']
})
export class ProgramDmusicComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
